import React, { useEffect, useState } from "react";
import { Modal, Form } from "react-bootstrap";
import { apiGetPersonnes, apiUpdatePersonne } from "../../../api/ApiPersonnes";
import { apiGetMarques } from "../../../api/ApiMarque";
import { useTranslation } from "react-i18next";
import {
  RiCheckboxMultipleBlankLine,
  RiCheckboxMultipleLine,
  RiFilterOffLine,
} from "react-icons/ri";
import { apiUpdateOrgunit } from "../../../api/ApiOrgunit";

const ModalChoixPersonnes = (props) => {
  const { t } = useTranslation();
  const { idOrgUnit, orgunitName, ReduxInstanceId, show, handleClose } = props;
  const [personnes, setPersonnes] = useState([]);
  const [personnesOri, setPersonnesOri] = useState([]);
  const [marquesPinned, setMarquesPinned] = useState([]);
  const [marquesUnPinned, setMarquesUnPinned] = useState([]);
  const [marquesPinnedSelected, setMarquesPinnedSelected] = useState(false);
  const [marquesUnPinnedSelected, setMarquesUnPinnedSelected] = useState(false);
  const [lettre, setLettre] = useState();

  const recupDatas = async () => {
    const res = await apiGetPersonnes(ReduxInstanceId);
    const resmarques = await apiGetMarques(ReduxInstanceId);

    setPersonnesOri(res.data);
    setPersonnes(res.data);

    if (resmarques.data) {
      let marquesPinned = [];
      let marquesUnPinned = [];
      resmarques.data
        .filter((item) => item.pinned)
        .forEach((element) => {
          marquesPinned.push(element._id);
        });
      resmarques.data
        .filter((item) => !item.pinned)
        .forEach((element) => {
          marquesUnPinned.push(element._id);
        });
      setMarquesPinned(marquesPinned);
      setMarquesUnPinned(marquesUnPinned);
      if (marquesPinned.length >= 1) {
        setMarquesPinnedSelected(true);
      }
    }
  };

  const addRemovePersonne = async (idPersonne) => {
    const personnesCopy = [...personnes];
    const index = personnesCopy.findIndex((item) => item._id === idPersonne);
    if (personnesCopy[index].orgUnitsParent.includes(idOrgUnit)) {
      personnesCopy[index].orgUnitsParent = personnesCopy[index].orgUnitsParent.filter(
        (item) => item !== idOrgUnit
      );
    } else {
      personnesCopy[index].orgUnitsParent.push(idOrgUnit);
    }

    const formData = new FormData();
    personnesCopy[index].orgUnitsParent.forEach((element) => {
      formData.append("orgUnitsParent[]", element);
    });
    await apiUpdatePersonne(personnesCopy[index]._id, formData);
    // mise a jour à blanc d'un orgunit pour changer la date d'update du orgUnit pour en suite s'en servir pour calcul sur table SOUS MISSIONS (revient presque à une commande TOUCH sur linux )
    await apiUpdateOrgunit(idOrgUnit);
    // fin mise a jour à blanc d'un orgunit pour changer la date d'update du orgUnit pour en suite s'en servir pour calcul sur table SOUS MISSIONS  (revient presque à une commande TOUCH sur linux )
    setPersonnes(personnesCopy);
  };

  useEffect(() => {
    if (show) {
      setMarquesPinnedSelected(false);
      setMarquesUnPinnedSelected(false);
      setLettre("");
      recupDatas();
    }
  }, [show]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (personnesOri.length) {
      let newPersonnes = personnesOri;
      let newPersonnesPinned = [];
      let newPersonnesUnPinned = [];

      if (marquesPinnedSelected) {
        newPersonnesPinned = personnesOri.filter((item) => marquesPinned.includes(item.marque));
      }
      if (marquesUnPinnedSelected) {
        newPersonnesUnPinned = personnesOri.filter((item) => marquesUnPinned.includes(item.marque));
      }

      if (marquesPinnedSelected && marquesUnPinnedSelected) {
        newPersonnes = newPersonnesPinned.concat(newPersonnesUnPinned);
      }
      if (marquesPinnedSelected && !marquesUnPinnedSelected) {
        newPersonnes = newPersonnesPinned;
      }
      if (!marquesPinnedSelected && marquesUnPinnedSelected) {
        newPersonnes = newPersonnesUnPinned;
      }
      if (!marquesPinnedSelected && !marquesUnPinnedSelected && marquesPinned.length >= 1) {
        newPersonnes = [];
      }

      if (lettre) {
        newPersonnes = newPersonnes.filter(
          (item) => item.prenom.charAt(0).toLowerCase() === lettre.toLowerCase()
        );
      }

      newPersonnes.sort((a, b) => (a.prenom > b.prenom ? 1 : b.prenom > a.prenom ? -1 : 0));
      setPersonnes(newPersonnes);
    }
  }, [marquesPinnedSelected, marquesUnPinnedSelected, lettre]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          {t("admin.PageAdminOrgunits.modalChoixPersonnesTitre")} "{orgunitName}"
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {marquesPinned.length >= 1 && (
          <div className="d-flex justify-content-between">
            <span onClick={(e) => setMarquesPinnedSelected(!marquesPinnedSelected)}>
              {marquesPinnedSelected ? (
                <RiCheckboxMultipleLine size="1.5em" role="button" className="text-danger" />
              ) : (
                <RiCheckboxMultipleBlankLine size="1.5em" role="button" className=" text-danger" />
              )}
              Sociétés principales
            </span>
            <span onClick={(e) => setMarquesUnPinnedSelected(!marquesUnPinnedSelected)}>
              {marquesUnPinnedSelected ? (
                <RiCheckboxMultipleLine size="1.5em" role="button" className="text-danger" />
              ) : (
                <RiCheckboxMultipleBlankLine size="1.5em" role="button" className=" text-danger" />
              )}
              Autres sociétés
            </span>
          </div>
        )}
        <div className="contentAlphabet fs-6 d-flex justify-content-center align-items-center flex-wrap">
          {lettre && (
            <span role="button" className="me-3" onClick={() => setLettre("")}>
              <RiFilterOffLine size="1.5em" role="button" />
            </span>
          )}
          <span
            role="button"
            onClick={() => setLettre("A")}
            className={lettre === "A" ? "bg-secondary" : ""}
          >
            A
          </span>
          <span
            role="button"
            onClick={() => setLettre("B")}
            className={lettre === "B" ? "bg-secondary" : ""}
          >
            B
          </span>
          <span
            role="button"
            onClick={() => setLettre("C")}
            className={lettre === "C" ? "bg-secondary" : ""}
          >
            C
          </span>
          <span
            role="button"
            onClick={() => setLettre("D")}
            className={lettre === "D" ? "bg-secondary" : ""}
          >
            D
          </span>
          <span
            role="button"
            onClick={() => setLettre("E")}
            className={lettre === "E" ? "bg-secondary" : ""}
          >
            E
          </span>
          <span
            role="button"
            onClick={() => setLettre("F")}
            className={lettre === "F" ? "bg-secondary" : ""}
          >
            F
          </span>
          <span
            role="button"
            onClick={() => setLettre("G")}
            className={lettre === "G" ? "bg-secondary" : ""}
          >
            G
          </span>
          <span
            role="button"
            onClick={() => setLettre("H")}
            className={lettre === "H" ? "bg-secondary" : ""}
          >
            H
          </span>
          <span
            role="button"
            onClick={() => setLettre("I")}
            className={lettre === "I" ? "bg-secondary" : ""}
          >
            I
          </span>
          <span
            role="button"
            onClick={() => setLettre("J")}
            className={lettre === "J" ? "bg-secondary" : ""}
          >
            J
          </span>
          <span
            role="button"
            onClick={() => setLettre("K")}
            className={lettre === "K" ? "bg-secondary" : ""}
          >
            K
          </span>
          <span
            role="button"
            onClick={() => setLettre("L")}
            className={lettre === "L" ? "bg-secondary" : ""}
          >
            L
          </span>

          <span
            role="button"
            onClick={() => setLettre("M")}
            className={lettre === "M" ? "bg-secondary" : ""}
          >
            M
          </span>
          <span
            role="button"
            onClick={() => setLettre("N")}
            className={lettre === "N" ? "bg-secondary" : ""}
          >
            N
          </span>
          <span
            role="button"
            onClick={() => setLettre("O")}
            className={lettre === "O" ? "bg-secondary" : ""}
          >
            O
          </span>
          <span
            role="button"
            onClick={() => setLettre("P")}
            className={lettre === "P" ? "bg-secondary" : ""}
          >
            P
          </span>
          <span
            role="button"
            onClick={() => setLettre("Q")}
            className={lettre === "Q" ? "bg-secondary" : ""}
          >
            Q
          </span>
          <span
            role="button"
            onClick={() => setLettre("R")}
            className={lettre === "R" ? "bg-secondary" : ""}
          >
            R
          </span>
          <span
            role="button"
            onClick={() => setLettre("S")}
            className={lettre === "S" ? "bg-secondary" : ""}
          >
            S
          </span>
          <span
            role="button"
            onClick={() => setLettre("T")}
            className={lettre === "T" ? "bg-secondary" : ""}
          >
            T
          </span>
          <span
            role="button"
            onClick={() => setLettre("U")}
            className={lettre === "U" ? "bg-secondary" : ""}
          >
            U
          </span>
          <span
            role="button"
            onClick={() => setLettre("V")}
            className={lettre === "V" ? "bg-secondary" : ""}
          >
            V
          </span>
          <span
            role="button"
            onClick={() => setLettre("W")}
            className={lettre === "W" ? "bg-secondary" : ""}
          >
            W
          </span>
          <span
            role="button"
            onClick={() => setLettre("X")}
            className={lettre === "X" ? "bg-secondary" : ""}
          >
            X
          </span>
          <span
            role="button"
            onClick={() => setLettre("Y")}
            className={lettre === "Y" ? "bg-secondary" : ""}
          >
            Y
          </span>
          <span
            role="button"
            onClick={() => setLettre("Z")}
            className={lettre === "Z" ? "bg-secondary" : ""}
          >
            Z
          </span>
        </div>
        <hr />
        {personnes.map((personne) => (
          <Form.Check
            key={personne._id}
            id={"personne_" + personne._id}
            type="switch"
            label={personne.prenom + " " + personne.nom}
            value={personne._id}
            onChange={(e) => {
              addRemovePersonne(e.target.value);
            }}
            checked={personne.orgUnitsParent.includes(idOrgUnit) ? "checked" : ""}
          />
        ))}
      </Modal.Body>
    </Modal>
  );
};

export default ModalChoixPersonnes;
